<template>
  <div
    v-if="isShow"
    class="mtb"
  >
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item
        v-for="(item, index) in breadcrumbList"
        :key="item.path"
      >
        <span v-if="index === breadcrumbList.length - 1">{{
          TLang(item.meta.crumbtitle, "my")
        }}</span>
        <span
          v-else
          @click="
            () => {
              $router.replace(item.path || '/');
            }
          "
        >{{ TLang(item.meta.crumbtitle, "my") }}</span>
      </el-breadcrumb-item>
    </el-breadcrumb>
  </div>
</template>

<script>
export default {
  name: 'BreadCrumb',
  props: {
    isShow: Boolean,
  },
  data() {
    return {
      breadcrumbList: null,
    };
  },
  watch: {
    $route() {
      this.getBreadcrumbList();
    },
  },
  created() {
    this.getBreadcrumbList();
  },
  methods: {
    getBreadcrumbList() {
      this.breadcrumbList = this.$route.matched.filter(
        (item) => item.name && item.name !== 'order',
      );
      this.breadcrumbList =
        this.breadcrumbList.length > 1 ? this.breadcrumbList : [];
    },
  },
};
</script>

<style scoped lang="less">
/deep/ .el-breadcrumb__inner {
  font-size: 12px;
  color: #999999 !important;

  &:last-child {
    font-size: 12px;
    color: #999999;
  }

  &:hover {
    font-size: 12px;
    color: #999999;
    cursor: pointer;
  }
}
</style>
